var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section-pages" },
    [
      _vm.showLoader
        ? _c("component-loader", {
            attrs: { progress: 90, unlimitedProgress: true, activeClose: true },
            on: {
              close: function ($event) {
                _vm.showLoader = false
              },
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "pages-sidebar head" }, [
        _c("div", { staticClass: "table-title" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("dash.pages.title")))]),
        ]),
      ]),
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            {
              attrs: {
                "vs-justify": "center",
                "vs-align": "center",
                "vs-w": "12",
              },
            },
            [
              ["Admin", "Editor"].includes(_vm.getUserRole)
                ? [
                    _vm.checkLock("pages")
                      ? _c(
                          "Tooltip",
                          {
                            attrs: {
                              text: _vm.$t("dash.locked"),
                              position: "top",
                            },
                          },
                          [
                            _c(
                              "vs-button",
                              {
                                staticClass: "btn-large btn-img",
                                attrs: {
                                  color: "#303030",
                                  "vs-type": "filled",
                                  disabled: "",
                                },
                                on: { click: _vm.addPage },
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("dash.pages.overlay.title"))
                                  ),
                                ]),
                                _c("img", {
                                  attrs: {
                                    src: require("../../../assets/img/icon_connect_white.svg"),
                                    alt: "new",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.checkLock("pages")
                      ? _c(
                          "vs-button",
                          {
                            staticClass: "btn-large btn-img",
                            attrs: { color: "#303030", "vs-type": "filled" },
                            on: { click: _vm.addPage },
                          },
                          [
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.$t("dash.pages.overlay.title"))
                              ),
                            ]),
                            _c("img", {
                              attrs: {
                                src: require("../../../assets/img/icon_connect_white.svg"),
                                alt: "new",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm.checkLock("pages")
                      ? _c(
                          "vs-button",
                          {
                            staticClass: "btn-large btn-img",
                            attrs: { color: "#303030", "vs-type": "filled" },
                            on: { click: _vm.goToSettings },
                          },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("dash.button.changeplan"))),
                            ]),
                            _c("img", {
                              attrs: {
                                src: require("../../../assets/img/icon_unlock.svg"),
                                alt: "unlock",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm.checkLock("admin")
                      ? _c(
                          "vs-button",
                          {
                            staticClass: "btn-large",
                            attrs: { color: "#303030", "vs-type": "filled" },
                            on: { click: _vm.addGroup },
                          },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("dash.pages.group.add"))),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _c(
                "div",
                { staticClass: "search-page" },
                [
                  _c("vs-input", {
                    staticClass: "inputx",
                    class: { input: true },
                    attrs: {
                      color: "#B20564",
                      "icon-after": "true",
                      icon: "search",
                      placeholder: _vm.$t(
                        "dash.settings.user.label.page_filter"
                      ),
                    },
                    on: {
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                      },
                    },
                    model: {
                      value: _vm.pageFilter,
                      callback: function ($$v) {
                        _vm.pageFilter = $$v
                      },
                      expression: "pageFilter",
                    },
                  }),
                ],
                1
              ),
              _c(
                "vs-popup",
                {
                  staticClass: "overlay groups",
                  attrs: {
                    title: _vm.$t("dash.pages.group.overlay.title"),
                    active: _vm.popupGroup,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.popupGroup = $event
                    },
                  },
                },
                [
                  _vm.popupGroup
                    ? _c("component-groups", {
                        attrs: {
                          group: _vm.group,
                          pages: _vm.linked,
                          groups: _vm.groups,
                        },
                        on: { close: _vm.closeGroupOverlay },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "vs-popup",
                {
                  staticClass: "overlay media-overlay",
                  attrs: {
                    title: _vm.$t("dash.pages.overlay.title"),
                    active: _vm.popup0,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.popup0 = $event
                    },
                  },
                },
                [
                  _c("div", { staticClass: "subtitle" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../assets/img/icon_connect_pink.svg"),
                        alt: "connexion",
                      },
                    }),
                    _c("p", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("dash.pages.overlay.txt0")) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "rs-buttons" },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            text: _vm.$t("dash.pages.facebook_connect"),
                            position: "top",
                          },
                        },
                        [
                          _c(
                            "vs-button",
                            {
                              staticClass: "facebook-btn btn-img btn-large",
                              on: { click: _vm.connectFB },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("dash.pages.overlay.connect"))
                                ),
                              ]),
                              _c("img", {
                                attrs: {
                                  src: require("../../../assets/img/ico-facebook-circle.png"),
                                  alt: "facebook",
                                },
                              }),
                            ]
                          ),
                          _vm._v(
                            "\n                       \n                    "
                          ),
                        ],
                        1
                      ),
                      !_vm.connected.instagram &&
                      _vm.checkLock("instagram") &&
                      !_vm.checkLock("partner") &&
                      _vm.hideToFB
                        ? _c(
                            "Tooltip",
                            {
                              attrs: {
                                text: _vm.$t("dash.pages.instagram_connect"),
                                position: "top",
                              },
                            },
                            [
                              _c(
                                "vs-button",
                                {
                                  staticClass:
                                    "instagram-btn btn-img btn-large",
                                  on: { click: _vm.connectInsta },
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.pages.overlay.connect")
                                      )
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/ico-instagram-circle.svg"),
                                      alt: "instagram",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                       \n                    "
                              ),
                            ],
                            1
                          )
                        : !_vm.connected.instagram &&
                          _vm.checkLock("instagram") &&
                          !_vm.checkLock("partner") &&
                          !_vm.hideToFB
                        ? [
                            _c(
                              "div",
                              { staticClass: "wrapper-connect-choice" },
                              [
                                _c(
                                  "Tooltip",
                                  {
                                    attrs: {
                                      text: _vm.$t(
                                        "dash.pages.instagram_connect"
                                      ),
                                      position: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "vs-button",
                                      {
                                        staticClass:
                                          "instagram-btn btn-img btn-large",
                                        on: { click: _vm.connectInsta },
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.pages.overlay.connect"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("img", {
                                          attrs: {
                                            src: require("../../../assets/img/ico-instagram-circle.svg"),
                                            alt: "instagram",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                           \n                        "
                                    ),
                                  ],
                                  1
                                ),
                                _vm.activeInstagramConciergerie
                                  ? _c(
                                      "div",
                                      { staticClass: "connect-type" },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.pages.instagram_connect.sandard"
                                              ),
                                              position: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "vs-button",
                                              {
                                                staticClass: "instagram-btn",
                                                on: { click: _vm.connectInsta },
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.pages.overlay.connect.sandard"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                             \n                          "
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.pages.instagram_connect.conciergerie"
                                              ),
                                              position: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "vs-button",
                                              {
                                                staticClass: "instagram-btn",
                                                on: {
                                                  click: _vm.connectInstaDirect,
                                                },
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.pages.overlay.connect.conciergerie"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c("span"),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  position: "top",
                                  text: _vm.$t("dash.locked"),
                                },
                              },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass:
                                      "instagram-btn btn-img btn-large",
                                    attrs: { disabled: "" },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.pages.overlay.connect")
                                        )
                                      ),
                                    ]),
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/ico-instagram-circle.svg"),
                                        alt: "instagram",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(
                                  "\n                             \n                        "
                                ),
                              ],
                              1
                            ),
                          ],
                      !_vm.connected.linkedin &&
                      _vm.checkLock("linkedin") &&
                      !_vm.checkLock("partner")
                        ? [
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  text: _vm.$t("dash.pages.linkedin_connect"),
                                },
                              },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass:
                                      "linkedin-btn btn-img btn-large",
                                    on: { click: _vm.connectLinkedin },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.pages.overlay.connect")
                                        )
                                      ),
                                    ]),
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/ico-linkedin-circle.svg"),
                                        alt: "linkedin",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(
                                  "\n                         \n                      "
                                ),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  position: "top",
                                  text: _vm.$t("dash.locked"),
                                },
                              },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass:
                                      "linkedin-btn btn-img btn-large",
                                    attrs: { disabled: "" },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.pages.overlay.connect")
                                        )
                                      ),
                                    ]),
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/ico-linkedin-circle.svg"),
                                        alt: "linkedin",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(
                                  "\n                             \n                        "
                                ),
                              ],
                              1
                            ),
                          ],
                      _vm.activeFeature("google")
                        ? _c(
                            "Tooltip",
                            {
                              attrs: {
                                text: _vm.$t("dash.pages.google_connect"),
                                position: "top",
                              },
                            },
                            [
                              _c(
                                "vs-button",
                                {
                                  ref: "loadingBotTarget",
                                  staticClass:
                                    "btn-img btn-large google-btn vs-con-loading__container",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.loginWithGoogle.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.pages.overlay.connect")
                                      )
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/ico-google-circle.png"),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                       \n                    "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.connected.twitter && _vm.checkLock("twitter_allowed")
                        ? [
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  text: _vm.$t("dash.pages.twitter_connect"),
                                },
                              },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass:
                                      "twitter-btn btn-img btn-large",
                                    on: { click: _vm.connectTwitter },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.pages.overlay.connect")
                                        )
                                      ),
                                    ]),
                                    _c("img", {
                                      staticStyle: { "border-radius": "50%" },
                                      attrs: {
                                        src: require("../../../assets/img/icon_tw.png"),
                                        alt: "twitter",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(
                                  "\n                         \n                      "
                                ),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  position: "top",
                                  text: _vm.$t("dash.locked"),
                                },
                              },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass:
                                      "twitter-btn btn-img btn-large",
                                    attrs: { disabled: "" },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.pages.overlay.connect")
                                        )
                                      ),
                                    ]),
                                    _c("img", {
                                      staticStyle: { "border-radius": "50%" },
                                      attrs: {
                                        src: require("../../../assets/img/icon_tw.png"),
                                        alt: "twitter",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(
                                  "\n                             \n                        "
                                ),
                              ],
                              1
                            ),
                          ],
                      _vm.activeFeature("threads")
                        ? _c(
                            "Tooltip",
                            {
                              attrs: {
                                text: _vm.$t("dash.pages.threads_connect"),
                                position: "top",
                              },
                            },
                            [
                              _c(
                                "vs-button",
                                {
                                  ref: "loadingBotTarget",
                                  staticClass:
                                    "btn-img btn-large threads-btn vs-con-loading__container",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.loginWithThreads.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.pages.overlay.connect")
                                      )
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/ico-threads-circle.svg"),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                       \n                    "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.activeFeature("youtube")
                        ? _c(
                            "Tooltip",
                            {
                              attrs: {
                                text: _vm.$t("dash.pages.youtube_connect"),
                                position: "top",
                              },
                            },
                            [
                              _c(
                                "vs-button",
                                {
                                  ref: "loadingBotTarget",
                                  staticClass:
                                    "btn-img btn-large youtube-btn vs-con-loading__container",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.loginWithYoutube.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.pages.overlay.connect")
                                      )
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/logo-youtube.svg"),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                       \n                    "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.connected.tiktok &&
                      _vm.checkLock("tiktok") &&
                      !_vm.checkLock("partner")
                        ? [
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  text: _vm.$t("dash.pages.tiktok_connect"),
                                  position: "top",
                                },
                              },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass: "tiktok-btn btn-img btn-large",
                                    on: { click: _vm.connectTiktok },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.pages.overlay.connect")
                                        )
                                      ),
                                    ]),
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/ico-tiktok-circle.png"),
                                        alt: "tiktok",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(
                                  "\n                         \n                      "
                                ),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  position: "top",
                                  text: _vm.$t("dash.locked"),
                                },
                              },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass: "tiktok-btn btn-img btn-large",
                                    attrs: { disabled: "" },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.pages.overlay.connect")
                                        )
                                      ),
                                    ]),
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/ico-tiktok-circle.png"),
                                        alt: "tiktok",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(
                                  "\n                             \n                        "
                                ),
                              ],
                              1
                            ),
                          ],
                      _vm.activeFeature("pinterest")
                        ? _c(
                            "Tooltip",
                            {
                              attrs: {
                                text: _vm.$t("dash.pages.pinterest_connect"),
                                position: "top",
                              },
                            },
                            [
                              _c(
                                "vs-button",
                                {
                                  ref: "loadingBotTarget",
                                  staticClass:
                                    "btn-img btn-large pinterest-btn",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.loginWithPinterest.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.pages.overlay.connect")
                                      )
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/ico-pinterest-circle.png"),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                       \n                    "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            text: _vm.$t("dash.pages.telegram_connect"),
                            position: "top",
                          },
                        },
                        [
                          _c(
                            "vs-button",
                            {
                              ref: "loadingBotTarget",
                              staticClass:
                                "btn-img btn-large telegram-btn vs-con-loading__container",
                              on: { click: _vm.openTelegramPopup },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("dash.pages.overlay.connect"))
                                ),
                              ]),
                              _c("img", {
                                attrs: {
                                  src: require("../../../assets/img/icon_telegram.png"),
                                },
                              }),
                            ]
                          ),
                          _vm._v(
                            "\n                       \n                    "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            text: _vm.$t("dash.pages.bluesky_connect"),
                            position: "top",
                          },
                        },
                        [
                          _c(
                            "vs-button",
                            {
                              ref: "loadingBotTarget",
                              staticClass: "btn-img btn-large bluesky-btn",
                              on: {
                                click: function ($event) {
                                  _vm.blueskyAuth.active = true
                                },
                              },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("dash.pages.overlay.connect"))
                                ),
                              ]),
                              _c("img", {
                                attrs: {
                                  src: require("../../../assets/img/icon_bluesky.png"),
                                },
                              }),
                            ]
                          ),
                          _vm._v(
                            "\n                       \n                    "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vs-popup",
                        {
                          staticClass: "overlay",
                          attrs: {
                            title: _vm.$t("dash.pages.bluesky_connect"),
                            active: _vm.blueskyAuth.active,
                          },
                          on: {
                            "update:active": function ($event) {
                              return _vm.$set(_vm.blueskyAuth, "active", $event)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "telegram-popup" },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "dash.pages.bluesky_connect_instruction"
                                    )
                                  )
                                ),
                              ]),
                              _c("vs-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "dash.pages.bluesky_login_placeholder"
                                  ),
                                  label: _vm.$t(
                                    "dash.pages.bluesky_login_label"
                                  ),
                                },
                                model: {
                                  value: _vm.blueskyAuth.login,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.blueskyAuth, "login", $$v)
                                  },
                                  expression: "blueskyAuth.login",
                                },
                              }),
                              _c("vs-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "dash.pages.bluesky_password_placeholder"
                                  ),
                                  type: "password",
                                  label: _vm.$t(
                                    "dash.pages.bluesky_password_label"
                                  ),
                                },
                                model: {
                                  value: _vm.blueskyAuth.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.blueskyAuth, "password", $$v)
                                  },
                                  expression: "blueskyAuth.password",
                                },
                              }),
                              _c(
                                "vs-button",
                                { on: { click: _vm.loginWithBluesky } },
                                [
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(
                                        _vm.$t("dash.pages.overlay.connect")
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                  _vm.activeFeature("push_notif_pub")
                    ? _c(
                        "div",
                        {
                          staticClass: "subtitle",
                          staticStyle: { "margin-top": "30px" },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../../assets/img/icon_bell_notification_ting_pink.svg"),
                              alt: "connexion",
                            },
                          }),
                          _c("p", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "dash.pages.overlay.notifications.txt0"
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.activeFeature("push_notif_pub")
                    ? _c(
                        "div",
                        {
                          staticClass: "rs-buttons",
                          staticStyle: { "margin-top": "15px" },
                        },
                        [
                          _c(
                            "Tooltip",
                            {
                              attrs: {
                                text: _vm.$t("dash.pages.oneSignal_connect"),
                                position: "top",
                              },
                            },
                            [
                              _c(
                                "vs-button",
                                {
                                  staticClass:
                                    "btn-img btn-large oneSignal-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openPushPopup("oneSignal")
                                    },
                                  },
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.pages.overlay.connect")
                                      )
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/icon_onesignal.png"),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                       \n                    "
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Tooltip",
                            {
                              attrs: {
                                text: _vm.$t("dash.pages.wonderpush_connect"),
                                position: "top",
                              },
                            },
                            [
                              _c(
                                "vs-button",
                                {
                                  staticClass:
                                    "btn-img btn-large wonderpush-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openPushPopup("wonderpush")
                                    },
                                  },
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.pages.overlay.connect")
                                      )
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/icon_wonderpush.png"),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                       \n                    "
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Tooltip",
                            {
                              attrs: {
                                text: _vm.$t("dash.pages.batch_connect"),
                                position: "top",
                              },
                            },
                            [
                              _c(
                                "vs-button",
                                {
                                  staticClass: "btn-img btn-large batch-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openPushPopup("batch")
                                    },
                                  },
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.pages.overlay.connect")
                                      )
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/icon_batch.png"),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                       \n                    "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                "vs-popup",
                {
                  staticClass: "overlay",
                  attrs: {
                    title: _vm.$t("dash.pages.telegram_connect"),
                    active: _vm.popupTelegram,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.popupTelegram = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "telegram-popup" },
                    [
                      _c("ol", { staticClass: "telegram-instructions" }, [
                        _c("li", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("dash.pages.telegram_instructions_1_1")
                              ) +
                              " \n                    "
                          ),
                          _c("b", { staticClass: "botname" }, [
                            _vm._v(_vm._s(_vm.telegramBotName)),
                          ]),
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("dash.pages.telegram_instructions_1_2")
                              ) +
                              "\n                    "
                          ),
                          _c("img", {
                            staticClass: "telegram-help",
                            attrs: {
                              src: require("../../../assets/img/icon_help.svg"),
                              alt: "?",
                            },
                            on: { click: () => _vm.openTelegramHelpGif(1) },
                          }),
                        ]),
                        _c("li", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("dash.pages.telegram_instructions_2")
                              ) +
                              "\n                    "
                          ),
                          _c("img", {
                            staticClass: "telegram-help",
                            attrs: {
                              src: require("../../../assets/img/icon_help.svg"),
                              alt: "?",
                            },
                            on: { click: () => _vm.openTelegramHelpGif(2) },
                          }),
                        ]),
                        _c("li", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("dash.pages.telegram_instructions_3")
                              ) +
                              "\n                    "
                          ),
                          _c("img", {
                            staticClass: "telegram-help",
                            attrs: {
                              src: require("../../../assets/img/icon_help.svg"),
                              alt: "?",
                            },
                            on: { click: () => _vm.openTelegramHelpGif(3) },
                          }),
                        ]),
                        _c("li", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("dash.pages.telegram_instructions_4")
                              ) +
                              "\n                    "
                          ),
                          _c("img", {
                            staticClass: "telegram-help",
                            attrs: {
                              src: require("../../../assets/img/icon_help.svg"),
                              alt: "?",
                            },
                            on: { click: () => _vm.openTelegramHelpGif(4) },
                          }),
                        ]),
                      ]),
                      _c("vs-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "dash.pages.telegram_channel_placeholder"
                          ),
                          label: _vm.$t("dash.pages.telegram_channel_label"),
                          danger: !_vm.telegramChannelUrlIsCorrect,
                          "danger-text": _vm.$t(
                            "dash.pages.telegram_channel_url_error"
                          ),
                        },
                        model: {
                          value: _vm.telegramChannelUrl,
                          callback: function ($$v) {
                            _vm.telegramChannelUrl = $$v
                          },
                          expression: "telegramChannelUrl",
                        },
                      }),
                      _c(
                        "vs-button",
                        { on: { click: _vm.validateTelegramChanel } },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.$t("dash.pages.overlay.connect")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "vs-popup",
                    {
                      staticClass: "help-popup",
                      attrs: {
                        title:
                          _vm.telegramInstructionGif === 1
                            ? _vm.$t(
                                `dash.pages.telegram_instructions_${_vm.telegramInstructionGif}_1`
                              ) +
                              " " +
                              _vm.telegramBotName +
                              " " +
                              _vm.$t(
                                `dash.pages.telegram_instructions_${_vm.telegramInstructionGif}_2`
                              )
                            : _vm.$t(
                                `dash.pages.telegram_instructions_${_vm.telegramInstructionGif}`
                              ),
                        active: _vm.telegramPopupHelp,
                      },
                      on: {
                        "update:active": function ($event) {
                          _vm.telegramPopupHelp = $event
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "gif-help",
                        attrs: {
                          src: require(`../../../assets/img/MW_Telegram_Instruction_${_vm.telegramInstructionGif}.gif`),
                          alt: "aide",
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vs-popup",
                {
                  staticClass: "overlay",
                  attrs: {
                    title: _vm.$t("dash.pages.groups_FB_connect"),
                    active: _vm.popupGroupsFB,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.popupGroupsFB = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "groups-fb-popup" },
                    [
                      _c("ol", { staticClass: "groups-fb-instructions" }, [
                        _c("li", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("dash.pages.groups_fb_instructions_1")
                              ) +
                              "\n                    "
                          ),
                          _c("img", {
                            staticClass: "groups-fb-help",
                            attrs: {
                              src: require("../../../assets/img/icon_help.svg"),
                              alt: "?",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openGroupsFBHelpGif(1)
                              },
                            },
                          }),
                        ]),
                        _c("li", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("dash.pages.groups_fb_instructions_2")
                              ) +
                              "\n                    "
                          ),
                          _c("img", {
                            staticClass: "groups-fb-help",
                            attrs: {
                              src: require("../../../assets/img/icon_help.svg"),
                              alt: "?",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openGroupsFBHelpGif(2)
                              },
                            },
                          }),
                        ]),
                        _c("li", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("dash.pages.groups_fb_instructions_3")
                              ) +
                              "\n                    "
                          ),
                          _c("img", {
                            staticClass: "groups-fb-help",
                            attrs: {
                              src: require("../../../assets/img/icon_help.svg"),
                              alt: "?",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openGroupsFBHelpGif(3)
                              },
                            },
                          }),
                        ]),
                        _c("li", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("dash.pages.groups_fb_instructions_4")
                            )
                          ),
                        ]),
                      ]),
                      _c("vs-button", { on: { click: _vm.connectGroupsFB } }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.$t("dash.pages.overlay.connect")) +
                            "\n                "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "vs-popup",
                    {
                      staticClass: "help-popup",
                      attrs: {
                        title: _vm.$t(
                          `dash.pages.groups_fb_instructions_${_vm.groupsFBInstructionGif}`
                        ),
                        active: _vm.groupsFBPopupHelp,
                      },
                      on: {
                        "update:active": function ($event) {
                          _vm.groupsFBPopupHelp = $event
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "gif-help",
                        attrs: {
                          src: require(`../../../assets/img/MW_Groups_FB_Instructions_${_vm.groupsFBInstructionGif}.gif`),
                          alt: "aide",
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vs-popup",
                {
                  staticClass: "overlay",
                  attrs: {
                    title: _vm.$t(
                      `dash.pages.${_vm.popupPush.network}_connect`
                    ),
                    active: _vm.popupPush.active,
                  },
                  on: {
                    "update:active": function ($event) {
                      return _vm.$set(_vm.popupPush, "active", $event)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { class: `${_vm.popupPush.network}-popup` },
                    [
                      _c(
                        "p",
                        { class: `${_vm.popupPush.network}-instructions` },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.$t(
                                  `dash.pages.${_vm.popupPush.network}_help`
                                )
                              ) +
                              "\n                  "
                          ),
                          _c("img", {
                            class: `${_vm.popupPush.network}-help`,
                            attrs: {
                              src: require("../../../assets/img/icon_help.svg"),
                              alt: "?",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openPushNotifHelpGif()
                              },
                            },
                          }),
                        ]
                      ),
                      _c("vs-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            `dash.pages.${_vm.popupPush.network}_name_placeholder`
                          ),
                          label: _vm.$t(
                            `dash.pages.${_vm.popupPush.network}_name_label`
                          ),
                          danger:
                            !_vm.popupPush.isCorrect &&
                            (!_vm.popupPush.name || _vm.popupPush.name == ""),
                          "danger-text": "required",
                        },
                        model: {
                          value: _vm.popupPush.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.popupPush, "name", $$v)
                          },
                          expression: "popupPush.name",
                        },
                      }),
                      _c("vs-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            `dash.pages.${_vm.popupPush.network}_network_id_placeholder`
                          ),
                          label: _vm.$t(
                            `dash.pages.${_vm.popupPush.network}_network_id_label`
                          ),
                          danger:
                            !_vm.popupPush.isCorrect &&
                            (!_vm.popupPush.network_id ||
                              _vm.popupPush.network_id == ""),
                          "danger-text": "required",
                        },
                        model: {
                          value: _vm.popupPush.network_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.popupPush, "network_id", $$v)
                          },
                          expression: "popupPush.network_id",
                        },
                      }),
                      _c("vs-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            `dash.pages.${_vm.popupPush.network}_token_placeholder`
                          ),
                          label: _vm.$t(
                            `dash.pages.${_vm.popupPush.network}_token_label`
                          ),
                          danger:
                            !_vm.popupPush.isCorrect &&
                            (!_vm.popupPush.token || _vm.popupPush.token == ""),
                          "danger-text": "required",
                        },
                        model: {
                          value: _vm.popupPush.token,
                          callback: function ($$v) {
                            _vm.$set(_vm.popupPush, "token", $$v)
                          },
                          expression: "popupPush.token",
                        },
                      }),
                      _c(
                        "vs-button",
                        { on: { click: _vm.validatePopupPush } },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.$t("dash.pages.overlay.connect")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.popupPush.active
                    ? _c(
                        "vs-popup",
                        {
                          staticClass: "help-popup",
                          attrs: {
                            title: _vm.$t(
                              `dash.pages.${_vm.popupPush.network}_help`
                            ),
                            active: _vm.pushNotifPopupHelp,
                          },
                          on: {
                            "update:active": function ($event) {
                              _vm.pushNotifPopupHelp = $event
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "gif-help",
                            attrs: {
                              src: require(`../../../assets/img/${_vm.popupPush.network}_help.jpg`),
                              alt: "aide",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "vs-popup",
                {
                  staticClass:
                    "overlay pages-overlay facebook-overlay linkedin-overlay",
                  attrs: {
                    title: _vm.$t(`dash.pages.add${_vm.getTypeNetwork}`),
                    active: _vm.popup1,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.popup1 = $event
                    },
                  },
                },
                [
                  _vm.popup1
                    ? _c("component-pages-overlay", {
                        attrs: {
                          liked: this.linked,
                          unliked: this.unlinked.filter(
                            (unlk) =>
                              !this.linked.some(
                                (lk) =>
                                  unlk.network_id.toString() ===
                                    lk.network_id.toString() ||
                                  (lk.story_config &&
                                    lk.story_config.onlyConciergerie &&
                                    lk.network === "facebook" &&
                                    unlk.name === lk.name)
                              )
                          ),
                          network: this.network,
                          isGroup: this.isGroup,
                        },
                        on: { close: _vm.validate },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "pages-content" }, [
                _vm.groups &&
                _vm.groups.length > 0 &&
                _vm.linked.length &&
                _vm.getGroupFilter().length
                  ? _c(
                      "div",
                      {
                        staticClass: "groups",
                        class: [
                          {
                            hide: !_vm.groups.some((g) =>
                              _vm.checkPagesInGroup(g)
                            ),
                          },
                        ],
                      },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("dash.pages.groups")) + " "),
                          _c("span", [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  _vm.groups.filter((g) =>
                                    _vm.checkPagesInGroup(g)
                                  ).length
                                ) +
                                ")"
                            ),
                          ]),
                        ]),
                        _c(
                          "ul",
                          _vm._l(_vm.groups, function (item) {
                            return _c(
                              "li",
                              {
                                key: item.id,
                                staticClass: "group",
                                class: [
                                  {
                                    hide:
                                      !_vm.checkPagesInGroup(item) ||
                                      _vm.checkGroupFilter(item),
                                  },
                                ],
                              },
                              [
                                _c("div", { staticClass: "name" }, [
                                  _vm._v(_vm._s(item.name) + " "),
                                  _c("span", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          item.pages.filter((p) =>
                                            _vm.findPage(p)
                                          ).length
                                        ) +
                                        ")"
                                    ),
                                  ]),
                                ]),
                                _vm.checkLock("admin")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "edit",
                                        on: {
                                          click: function ($event) {
                                            return _vm.editGroup(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("dash.pages.groups.edit")
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "to-show",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleShowGroup(item)
                                      },
                                    },
                                  },
                                  [
                                    item.show
                                      ? _c("img", {
                                          staticClass: "hide-group",
                                          attrs: {
                                            alt: "hide group",
                                            src: require("../../../assets/img/icon-hide-group-1.svg"),
                                          },
                                        })
                                      : _c("img", {
                                          staticClass: "show-group",
                                          attrs: {
                                            alt: "show group",
                                            src: require("../../../assets/img/icon-show-group-1.svg"),
                                          },
                                        }),
                                    item.show
                                      ? _c(
                                          "span",
                                          { staticClass: "hide-group" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("dash.pages.group.hide")
                                              )
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "show-group" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("dash.pages.group.show")
                                              )
                                            ),
                                          ]
                                        ),
                                  ]
                                ),
                                _c(
                                  "i",
                                  {
                                    staticClass:
                                      "material-icons position-group-up",
                                    on: {
                                      click: function ($event) {
                                        return _vm.changePositionGroup(
                                          item,
                                          "up"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("keyboard_arrow_up")]
                                ),
                                _c(
                                  "i",
                                  {
                                    staticClass:
                                      "material-icons position-group-down",
                                    on: {
                                      click: function ($event) {
                                        return _vm.changePositionGroup(
                                          item,
                                          "down"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("keyboard_arrow_down")]
                                ),
                                _c(
                                  "ul",
                                  { class: [{ show: item.show }] },
                                  _vm._l(item.pages, function (pageId) {
                                    return _c(
                                      "div",
                                      {
                                        key: pageId,
                                        class: [
                                          {
                                            hide: !_vm.checkPageFilter(
                                              _vm.findPage(pageId)
                                            ),
                                          },
                                        ],
                                      },
                                      [
                                        _vm.findPage(pageId)
                                          ? _c(
                                              "li",
                                              {
                                                staticClass: "page",
                                                class: {
                                                  disabled:
                                                    !_vm.checkLock(
                                                      _vm.findPage(pageId)
                                                        .network
                                                    ) ||
                                                    (!_vm.isUserPremiumActive &&
                                                      _vm.orderedPages.length &&
                                                      _vm.orderedPages[0].id !=
                                                        pageId &&
                                                      !_vm.isUserPartner),
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons edit-name",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.editPageName =
                                                          _vm.findPage(pageId)
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("edit")]
                                                ),
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons open-page",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.openPage(
                                                          _vm.findPage(pageId)
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("link")]
                                                ),
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons position-up",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.changePositionPageInGroup(
                                                          item,
                                                          _vm.findPage(pageId),
                                                          "up"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("keyboard_arrow_up")]
                                                ),
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons position-down",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.changePositionPageInGroup(
                                                          item,
                                                          _vm.findPage(pageId),
                                                          "down"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "keyboard_arrow_down"
                                                    ),
                                                  ]
                                                ),
                                                _c("page-image-avatar", {
                                                  attrs: {
                                                    page: _vm.findPage(pageId),
                                                  },
                                                }),
                                                _c(
                                                  "p",
                                                  { staticClass: "page-name" },
                                                  [
                                                    _vm._v(
                                                      "\n                            " +
                                                        _vm._s(
                                                          _vm.findPage(pageId)
                                                            .name
                                                        ) +
                                                        "\n                            "
                                                    ),
                                                    (_vm.activeLinkedinConciergerie &&
                                                      _vm.findPage(pageId)
                                                        .network ==
                                                        "linkedin") ||
                                                    (_vm.activeInstagramConciergerie &&
                                                      _vm.findPage(pageId)
                                                        .network ==
                                                        "instagram") ||
                                                    (_vm.activeFacebookConciergerie &&
                                                      _vm.findPage(pageId)
                                                        .network ==
                                                        "facebook" &&
                                                      (_vm.findPage(pageId)
                                                        .isGroup ||
                                                        !_vm.isProd() ||
                                                        (_vm.findPage(pageId)
                                                          .story_config &&
                                                          _vm.findPage(pageId)
                                                            .story_config
                                                            .created))) ||
                                                    (_vm.activeTiktokConciergerie &&
                                                      _vm.findPage(pageId)
                                                        .network == "tiktok") ||
                                                    (_vm.activeTwitterConciergerie &&
                                                      _vm.findPage(pageId)
                                                        .network == "twitter" &&
                                                      !_vm.isProd())
                                                      ? _c(
                                                          "component-conciergerie",
                                                          {
                                                            attrs: {
                                                              page: _vm.findPage(
                                                                pageId
                                                              ),
                                                            },
                                                            on: {
                                                              getPagesEvent:
                                                                _vm.getPagesEvent,
                                                              closeActiveConciergerie:
                                                                _vm.closeActiveConciergerie,
                                                            },
                                                          }
                                                        )
                                                      : [
                                                          "instagram",
                                                          "linkedin",
                                                        ].includes(
                                                          _vm.findPage(pageId)
                                                            .network
                                                        )
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: "Conciergerie",
                                                              position: "top",
                                                            },
                                                          },
                                                          [
                                                            _c("img", {
                                                              staticClass:
                                                                "conciergerie",
                                                              attrs: {
                                                                src: require("../../../assets/img/bell_concierge.svg"),
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.changePlanConciergerie = true
                                                                  },
                                                              },
                                                            }),
                                                            _vm._v(
                                                              " \n                               \n                            "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                ["Admin", "Editor"].includes(
                                                  _vm.getUserRole
                                                )
                                                  ? [
                                                      !_vm.checkLock(
                                                        _vm.findPage(pageId)
                                                          .network
                                                      ) ||
                                                      (!_vm.isUserPremiumActive &&
                                                        _vm.orderedPages
                                                          .length &&
                                                        _vm.orderedPages[0]
                                                          .id != pageId &&
                                                        !_vm.isUserPartner)
                                                        ? _c(
                                                            "vs-button",
                                                            {
                                                              staticClass:
                                                                "btn-large btn-img remove",
                                                              attrs: {
                                                                color:
                                                                  "#6a1f4c",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "delete"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "dash.pages.group.remove"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _c(
                                                            "vs-button",
                                                            {
                                                              staticClass:
                                                                "btn-large btn-img remove",
                                                              attrs: {
                                                                color:
                                                                  "#6a1f4c",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.deleteLinkedFromGroup(
                                                                      _vm.findPage(
                                                                        pageId
                                                                      ),
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "delete"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "dash.pages.group.remove"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                      _c("div", {
                                                        staticClass: "border",
                                                      }),
                                                    ]
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "status-refresh",
                                                  },
                                                  [
                                                    (_vm.activeLinkedinConciergerie ||
                                                      _vm.activeInstagramConciergerie ||
                                                      _vm.activeFacebookConciergerie ||
                                                      _vm.activeTiktokConciergerie) &&
                                                    !!_vm.findPage(pageId)
                                                      .bot_status &&
                                                    _vm.findPage(pageId)
                                                      .instagram_username &&
                                                    (!_vm.findPage(pageId)
                                                      .story_config ||
                                                      !_vm.findPage(pageId)
                                                        .story_config.created)
                                                      ? [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              staticClass:
                                                                "reconnect-btn",
                                                              attrs: {
                                                                text: _vm.$t(
                                                                  "dash.bots.status_proxy"
                                                                ),
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_wait_proxy.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.reconnectePage(
                                                                        pageId
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _c("a", {
                                                                attrs: {
                                                                  href: "#",
                                                                },
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.pages.reconnectLabel"
                                                                      )
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.reconnectePage(
                                                                        pageId
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _c("span", [
                                                                _vm._v(" "),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      : (_vm.activeLinkedinConciergerie ||
                                                          _vm.activeInstagramConciergerie ||
                                                          _vm.activeFacebookConciergerie ||
                                                          _vm.activeTiktokConciergerie) &&
                                                        ((_vm.findPage(pageId)
                                                          .isGroup &&
                                                          _vm.findPage(pageId)
                                                            .network ==
                                                            "instagram") ||
                                                          (_vm.findPage(pageId)
                                                            .story_config &&
                                                            _vm.findPage(pageId)
                                                              .story_config
                                                              .onlyConciergerie)) &&
                                                        (!_vm.findPage(pageId)
                                                          .story_config ||
                                                          !_vm.findPage(pageId)
                                                            .story_config
                                                            .created)
                                                      ? [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              class:
                                                                _vm.findPage(
                                                                  pageId
                                                                ).network ===
                                                                  "facebook" &&
                                                                (_vm.findPage(
                                                                  pageId
                                                                ).isGroup ||
                                                                  (_vm.findPage(
                                                                    pageId
                                                                  )
                                                                    .story_config &&
                                                                    _vm.findPage(
                                                                      pageId
                                                                    )
                                                                      .story_config
                                                                      .onlyConciergerie))
                                                                  ? ""
                                                                  : "reconnect-btn",
                                                              attrs: {
                                                                text: _vm.$t(
                                                                  "dash.bots.status_proxy"
                                                                ),
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_wait_proxy.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.reconnectePage(
                                                                        pageId
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _c("a", {
                                                                attrs: {
                                                                  href: "#",
                                                                },
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.pages.reconnectLabel"
                                                                      )
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.reconnectePage(
                                                                        pageId
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _c("span", [
                                                                _vm._v(" "),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      : (_vm.findPage(pageId)
                                                          .isGroup &&
                                                          _vm.findPage(pageId)
                                                            .network ==
                                                            "instagram") ||
                                                        (_vm.findPage(pageId)
                                                          .story_config &&
                                                          _vm.findPage(pageId)
                                                            .story_config
                                                            .onlyConciergerie)
                                                      ? [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              staticClass:
                                                                "full-conciergerie",
                                                              attrs: {
                                                                text: _vm.$t(
                                                                  "dash.bots.conciergerie-ok"
                                                                ),
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              !(
                                                                _vm.findPage(
                                                                  pageId
                                                                ).network ===
                                                                  "facebook" &&
                                                                (_vm.findPage(
                                                                  pageId
                                                                ).isGroup ||
                                                                  (_vm.findPage(
                                                                    pageId
                                                                  )
                                                                    .story_config &&
                                                                    _vm.findPage(
                                                                      pageId
                                                                    )
                                                                      .story_config
                                                                      .onlyConciergerie))
                                                              )
                                                                ? _c("span", {
                                                                    staticClass:
                                                                      "border",
                                                                  })
                                                                : _vm._e(),
                                                              _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_check_light.svg"),
                                                                },
                                                              }),
                                                              _c("span", [
                                                                _vm._v(" "),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    !_vm.checkLock(
                                                      _vm.findPage(pageId)
                                                        .network
                                                    ) ||
                                                    (!_vm.isUserPremiumActive &&
                                                      _vm.orderedPages.length &&
                                                      _vm.orderedPages[0].id !=
                                                        _vm.findPage(pageId)
                                                          .id &&
                                                      !_vm.isUserPartner)
                                                      ? [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.getTooltipText(
                                                                  _vm.findPage(
                                                                    pageId
                                                                  )
                                                                ),
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_check_light.svg"),
                                                                },
                                                              }),
                                                              _c("span", [
                                                                _vm._v(" "),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      : _vm.findPage(pageId)
                                                          .network ===
                                                          "facebook" &&
                                                        (_vm.findPage(pageId)
                                                          .isGroup ||
                                                          (_vm.findPage(pageId)
                                                            .story_config &&
                                                            _vm.findPage(pageId)
                                                              .story_config
                                                              .onlyConciergerie &&
                                                            _vm.findPage(pageId)
                                                              .story_config
                                                              .isPersonal))
                                                      ? void 0
                                                      : _vm.findPage(pageId)
                                                          .network ===
                                                          "facebook" &&
                                                        _vm.findPage(pageId)
                                                          .story_config &&
                                                        _vm.findPage(pageId)
                                                          .story_config
                                                          .onlyConciergerie &&
                                                        !_vm.findPage(pageId)
                                                          .story_config
                                                          .isPersonal
                                                      ? [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.$t(
                                                                  "dash.bots.conciergerie-ok-api-ko"
                                                                ),
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon-delete.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.confirmRefresh(
                                                                        _vm.findPage(
                                                                          pageId
                                                                        )
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _c("span", [
                                                                _vm._v(" "),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      : (_vm.findPage(pageId)
                                                          .isGroup &&
                                                          _vm.findPage(pageId)
                                                            .network ==
                                                            "instagram") ||
                                                        (_vm.findPage(pageId)
                                                          .story_config &&
                                                          _vm.findPage(pageId)
                                                            .story_config
                                                            .onlyConciergerie)
                                                      ? [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.$t(
                                                                  "dash.bots.conciergerie-ok-api-ko"
                                                                ),
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon-delete.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.confirmRefresh(
                                                                        _vm.findPage(
                                                                          pageId
                                                                        )
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _c("span", [
                                                                _vm._v(" "),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      : !!_vm.findPage(pageId)
                                                          .bot_status &&
                                                        _vm.findPage(pageId)
                                                          .bot_status == 1
                                                      ? [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.getTooltipText(
                                                                  _vm.findPage(
                                                                    pageId
                                                                  )
                                                                ),
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _vm.findPage(
                                                                pageId
                                                              ).network ==
                                                              "bluesky"
                                                                ? _c(
                                                                    "vs-avatar",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "transparent",
                                                                        size: "18px",
                                                                        src: require("../../../assets/img/icon_check_light.svg"),
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            _vm.blueskyAuth.active = true
                                                                          },
                                                                      },
                                                                    }
                                                                  )
                                                                : _c(
                                                                    "vs-avatar",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "transparent",
                                                                        size: "18px",
                                                                        src: require("../../../assets/img/icon_check_light.svg"),
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            _vm.confirmRefresh(
                                                                              _vm.findPage(
                                                                                pageId
                                                                              )
                                                                            )
                                                                          },
                                                                      },
                                                                    }
                                                                  ),
                                                              _c("span", [
                                                                _vm._v(" "),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      : !!_vm.findPage(pageId)
                                                          .bot_status &&
                                                        _vm.findPage(pageId)
                                                          .bot_status == 2
                                                      ? [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text:
                                                                  _vm.$t(
                                                                    "dash.bots.status_near_expiration"
                                                                  ) +
                                                                  new Date(
                                                                    _vm.findPage(
                                                                      pageId
                                                                    ).bot_error
                                                                  ).toLocaleDateString(),
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_warn.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.confirmRefresh(
                                                                        _vm.findPage(
                                                                          pageId
                                                                        )
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _c("a", {
                                                                attrs: {
                                                                  href: "#",
                                                                },
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.pages.refreshLabel"
                                                                      )
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.confirmRefresh(
                                                                        _vm.findPage(
                                                                          pageId
                                                                        )
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      : _vm.findPage(pageId)
                                                          .bot_status == 0 &&
                                                        !_vm.checkLock(
                                                          "source_choice"
                                                        )
                                                      ? [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.findPage(
                                                                  pageId
                                                                ).bot_error,
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_stop.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      ;[
                                                                        "Admin",
                                                                        "Editor",
                                                                      ].includes(
                                                                        _vm.getUserRole
                                                                      )
                                                                        ? _vm.goToSettings()
                                                                        : null
                                                                    },
                                                                },
                                                              }),
                                                              _vm.findPage(
                                                                pageId
                                                              ).network ==
                                                              "bluesky"
                                                                ? _c("a", {
                                                                    attrs: {
                                                                      href: "#",
                                                                    },
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "dash.pages.refreshLabel"
                                                                          )
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.blueskyAuth.active = true
                                                                        },
                                                                    },
                                                                  })
                                                                : _c("a", {
                                                                    attrs: {
                                                                      href: "#",
                                                                    },
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "dash.pages.refreshLabel"
                                                                          )
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.confirmRefresh(
                                                                            _vm.findPage(
                                                                              pageId
                                                                            )
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                              _c("span", [
                                                                _vm._v(" "),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      : _vm.findPage(pageId)
                                                          .bot_status == 0 &&
                                                        _vm.findPage(pageId)
                                                          .network == "linkedin"
                                                      ? [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.$t(
                                                                  "dash.bots.status_expired"
                                                                ),
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_stop.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.confirmRefresh(
                                                                        _vm.findPage(
                                                                          pageId
                                                                        )
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _c("a", {
                                                                attrs: {
                                                                  href: "#",
                                                                },
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.pages.refreshLabel"
                                                                      )
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.confirmRefresh(
                                                                        _vm.findPage(
                                                                          pageId
                                                                        )
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      : _vm.findPage(pageId)
                                                          .bot_status == 3
                                                      ? [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.$t(
                                                                  _vm.findPage(
                                                                    pageId
                                                                  ).bot_error
                                                                ),
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_stop.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      ;[
                                                                        "Admin",
                                                                        "Editor",
                                                                      ].includes(
                                                                        _vm.getUserRole
                                                                      )
                                                                        ? _vm.reactivateBot(
                                                                            pageId
                                                                          )
                                                                        : null
                                                                    },
                                                                },
                                                              }),
                                                              _c("a", {
                                                                attrs: {
                                                                  href: "#",
                                                                },
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.sources.enable"
                                                                      )
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      ;[
                                                                        "Admin",
                                                                        "Editor",
                                                                      ].includes(
                                                                        _vm.getUserRole
                                                                      )
                                                                        ? _vm.reactivateBot(
                                                                            pageId
                                                                          )
                                                                        : null
                                                                    },
                                                                },
                                                              }),
                                                              _c("span", [
                                                                _vm._v(" "),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      : _vm.checkLock(
                                                          _vm.findPage(pageId)
                                                            .network
                                                        )
                                                      ? [
                                                          _vm.findPage(pageId)
                                                            .network ==
                                                          "bluesky"
                                                            ? _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_check_light.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.blueskyAuth.active = true
                                                                    },
                                                                },
                                                              })
                                                            : _vm._e(),
                                                          _vm.findPage(pageId)
                                                            .network ==
                                                          "bluesky"
                                                            ? _c(
                                                                "Tooltip",
                                                                {
                                                                  attrs: {
                                                                    text: _vm.findPage(
                                                                      pageId
                                                                    ).bot_error,
                                                                    position:
                                                                      "top",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "vs-avatar",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "transparent",
                                                                        size: "18px",
                                                                        src: require("../../../assets/img/icon_stop.svg"),
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            _vm.blueskyAuth.active = true
                                                                          },
                                                                      },
                                                                    }
                                                                  ),
                                                                  _c("a", {
                                                                    attrs: {
                                                                      href: "#",
                                                                    },
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "dash.pages.refreshLabel"
                                                                          )
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.blueskyAuth.active = true
                                                                        },
                                                                    },
                                                                  }),
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "Tooltip",
                                                                {
                                                                  attrs: {
                                                                    text: _vm.findPage(
                                                                      pageId
                                                                    ).bot_error,
                                                                    position:
                                                                      "top",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "vs-avatar",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "transparent",
                                                                        size: "18px",
                                                                        src: require("../../../assets/img/icon_stop.svg"),
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            _vm.confirmRefresh(
                                                                              _vm.findPage(
                                                                                pageId
                                                                              )
                                                                            )
                                                                          },
                                                                      },
                                                                    }
                                                                  ),
                                                                  _c("a", {
                                                                    attrs: {
                                                                      href: "#",
                                                                    },
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "dash.pages.refreshLabel"
                                                                          )
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.confirmRefresh(
                                                                            _vm.findPage(
                                                                              pageId
                                                                            )
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                ],
                                                                1
                                                              ),
                                                        ]
                                                      : _vm.findPage(pageId)
                                                          .network == "bluesky"
                                                      ? [
                                                          _c("vs-avatar", {
                                                            staticStyle: {
                                                              cursor: "default",
                                                            },
                                                            attrs: {
                                                              color:
                                                                "transparent",
                                                              size: "18px",
                                                              src: require("../../../assets/img/icon_stop.svg"),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.blueskyAuth.active = true
                                                              },
                                                            },
                                                          }),
                                                          _c("a", {
                                                            attrs: {
                                                              href: "#",
                                                            },
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "dash.pages.refreshLabel"
                                                                )
                                                              ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.blueskyAuth.active = true
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      : [
                                                          _c("vs-avatar", {
                                                            staticStyle: {
                                                              cursor: "default",
                                                            },
                                                            attrs: {
                                                              color:
                                                                "transparent",
                                                              size: "18px",
                                                              src: require("../../../assets/img/icon_stop.svg"),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.confirmRefresh(
                                                                  _vm.findPage(
                                                                    pageId
                                                                  )
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _c("a", {
                                                            attrs: {
                                                              href: "#",
                                                            },
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "dash.pages.refreshLabel"
                                                                )
                                                              ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.confirmRefresh(
                                                                  _vm.findPage(
                                                                    pageId
                                                                  )
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ],
                                                  ],
                                                  2
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "type" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.findPage(pageId)
                                                          .network
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.listPages.length && _vm.getPageFilter().length
                  ? _c(
                      "div",
                      { staticClass: "pages" },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.groups && _vm.groups.length > 0
                                ? _vm.$t("dash.pages.groups.without")
                                : _vm.$t("dash.pages.title")
                            ) + " "
                          ),
                          _c("span", [
                            _vm._v("(" + _vm._s(_vm.listPages.length) + ")"),
                          ]),
                        ]),
                        _c(
                          "vs-table",
                          {
                            attrs: { hoverFlat: true, data: _vm.listPages },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ data }) {
                                    return _vm._l(data, function (item, index) {
                                      return _c(
                                        "vs-tr",
                                        {
                                          key: item.id,
                                          class: [
                                            {
                                              hide: !_vm.checkPageFilter(item),
                                              disabled:
                                                !_vm.checkLock(item.network) ||
                                                (!_vm.isUserPremiumActive &&
                                                  _vm.orderedPages.length &&
                                                  _vm.orderedPages[0].id !=
                                                    item.id &&
                                                  !_vm.isUserPartner),
                                            },
                                          ],
                                        },
                                        [
                                          _c(
                                            "vs-td",
                                            {
                                              staticClass: "name",
                                              attrs: { data: item.name },
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "material-icons edit-name",
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.editPageName = item
                                                    },
                                                  },
                                                },
                                                [_vm._v("edit")]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "material-icons open-page",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openPage(item)
                                                    },
                                                  },
                                                },
                                                [_vm._v("link")]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "material-icons position-up",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.changePositionPage(
                                                        item,
                                                        "up"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("keyboard_arrow_up")]
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "material-icons position-down",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.changePositionPage(
                                                        item,
                                                        "down"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("keyboard_arrow_down")]
                                              ),
                                              _c("page-image-avatar", {
                                                attrs: { page: item },
                                              }),
                                              _c(
                                                "p",
                                                { staticClass: "page-name" },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(item.name) +
                                                      "\n                          "
                                                  ),
                                                  (_vm.activeLinkedinConciergerie &&
                                                    item.network ==
                                                      "linkedin") ||
                                                  (_vm.activeInstagramConciergerie &&
                                                    item.network ==
                                                      "instagram") ||
                                                  (_vm.activeFacebookConciergerie &&
                                                    item.network ==
                                                      "facebook" &&
                                                    (item.isGroup ||
                                                      !_vm.isProd() ||
                                                      (item.story_config &&
                                                        item.story_config
                                                          .created))) ||
                                                  (_vm.activeTiktokConciergerie &&
                                                    item.network == "tiktok") ||
                                                  (_vm.activeTwitterConciergerie &&
                                                    item.network == "twitter" &&
                                                    !_vm.isProd())
                                                    ? _c(
                                                        "component-conciergerie",
                                                        {
                                                          attrs: { page: item },
                                                          on: {
                                                            getPagesEvent:
                                                              _vm.getPagesEvent,
                                                            closeActiveConciergerie:
                                                              _vm.closeActiveConciergerie,
                                                          },
                                                        }
                                                      )
                                                    : [
                                                        "instagram",
                                                        "linkedin",
                                                      ].includes(item.network)
                                                    ? _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: "Conciergerie",
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "conciergerie",
                                                            attrs: {
                                                              src: require("../../../assets/img/bell_concierge.svg"),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.changePlanConciergerie = true
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(
                                                            " \n                               \n                            "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _c("div", {}),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "vs-td",
                                            {
                                              staticClass: "type",
                                              attrs: { data: item.network },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(item.network) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _c("vs-td", [
                                            _c(
                                              "div",
                                              { staticClass: "status-refresh" },
                                              [
                                                (_vm.activeLinkedinConciergerie ||
                                                  _vm.activeInstagramConciergerie ||
                                                  _vm.activeFacebookConciergerie ||
                                                  _vm.activeTiktokConciergerie) &&
                                                item.bot_status &&
                                                item.instagram_username &&
                                                (!item.story_config ||
                                                  !item.story_config.created)
                                                  ? [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          staticClass:
                                                            "reconnect-btn-list",
                                                          attrs: {
                                                            text: _vm.$t(
                                                              "dash.bots.status_proxy"
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "border",
                                                          }),
                                                          _c("vs-avatar", {
                                                            attrs: {
                                                              color:
                                                                "transparent",
                                                              size: "18px",
                                                              src: require("../../../assets/img/icon_wait_proxy.svg"),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.reconnectePage(
                                                                  item.id
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _c("a", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "dash.pages.reconnectLabel"
                                                                )
                                                              ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.reconnectePage(
                                                                  item.id
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _c("span", [
                                                            _vm._v(" "),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : (_vm.activeLinkedinConciergerie ||
                                                      _vm.activeInstagramConciergerie ||
                                                      _vm.activeFacebookConciergerie ||
                                                      _vm.activeTiktokConciergerie) &&
                                                    ((item.isGroup &&
                                                      item.network ==
                                                        "instagram") ||
                                                      (item.story_config &&
                                                        item.story_config
                                                          .onlyConciergerie)) &&
                                                    (!item.story_config ||
                                                      !item.story_config
                                                        .created)
                                                  ? [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          class:
                                                            item.network ===
                                                              "facebook" &&
                                                            (item.isGroup ||
                                                              (item.story_config &&
                                                                item
                                                                  .story_config
                                                                  .onlyConciergerie))
                                                              ? ""
                                                              : "reconnect-btn",
                                                          attrs: {
                                                            text: _vm.$t(
                                                              "dash.bots.status_proxy"
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("vs-avatar", {
                                                            attrs: {
                                                              color:
                                                                "transparent",
                                                              size: "18px",
                                                              src: require("../../../assets/img/icon_wait_proxy.svg"),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.reconnectePage(
                                                                  item.id
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _c("a", {
                                                            attrs: {
                                                              href: "#",
                                                            },
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "dash.pages.reconnectLabel"
                                                                )
                                                              ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.reconnectePage(
                                                                  item.id
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _c("span", [
                                                            _vm._v(" "),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : (item.isGroup &&
                                                      item.network ==
                                                        "instagram") ||
                                                    (item.story_config &&
                                                      item.story_config
                                                        .onlyConciergerie)
                                                  ? [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          staticClass:
                                                            "full-conciergerie",
                                                          attrs: {
                                                            text: _vm.$t(
                                                              "dash.bots.conciergerie-ok"
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          !(
                                                            item.network ===
                                                              "facebook" &&
                                                            (item.isGroup ||
                                                              (item.story_config &&
                                                                item
                                                                  .story_config
                                                                  .onlyConciergerie))
                                                          )
                                                            ? _c("span", {
                                                                staticClass:
                                                                  "border",
                                                              })
                                                            : _vm._e(),
                                                          _c("vs-avatar", {
                                                            attrs: {
                                                              color:
                                                                "transparent",
                                                              size: "18px",
                                                              src: require("../../../assets/img/icon_check_light.svg"),
                                                            },
                                                          }),
                                                          _c("span", [
                                                            _vm._v(" "),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                                !_vm.checkLock(item.network) ||
                                                (!_vm.isUserPremiumActive &&
                                                  _vm.orderedPages.length &&
                                                  _vm.orderedPages[0].id !=
                                                    item.id &&
                                                  !_vm.isUserPartner)
                                                  ? [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: _vm.getTooltipText(
                                                              item
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("vs-avatar", {
                                                            attrs: {
                                                              color:
                                                                "transparent",
                                                              size: "18px",
                                                              src: require("../../../assets/img/icon_check_light.svg"),
                                                            },
                                                          }),
                                                          _c("span", [
                                                            _vm._v(" "),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : item.network ===
                                                      "facebook" &&
                                                    (item.isGroup ||
                                                      (item.story_config &&
                                                        item.story_config
                                                          .onlyConciergerie &&
                                                        item.story_config
                                                          .isPersonal))
                                                  ? void 0
                                                  : item.network ===
                                                      "facebook" &&
                                                    item.story_config &&
                                                    item.story_config
                                                      .onlyConciergerie &&
                                                    !item.story_config
                                                      .isPersonal
                                                  ? [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: _vm.$t(
                                                              "dash.bots.conciergerie-ok-api-ko"
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("vs-avatar", {
                                                            attrs: {
                                                              color:
                                                                "transparent",
                                                              size: "18px",
                                                              src: require("../../../assets/img/icon-delete.svg"),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.confirmRefresh(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _c("span", [
                                                            _vm._v(" "),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : (item.isGroup &&
                                                      item.network ==
                                                        "instagram") ||
                                                    (item.story_config &&
                                                      item.story_config
                                                        .onlyConciergerie)
                                                  ? [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: _vm.$t(
                                                              "dash.bots.conciergerie-ok-api-ko"
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("vs-avatar", {
                                                            attrs: {
                                                              color:
                                                                "transparent",
                                                              size: "18px",
                                                              src: require("../../../assets/img/icon-delete.svg"),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.confirmRefresh(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _c("span", [
                                                            _vm._v(" "),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : !!item.bot_status &&
                                                    item.bot_status == 1
                                                  ? [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: _vm.getTooltipText(
                                                              item
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          item.network ==
                                                          "bluesky"
                                                            ? _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_check_light.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.blueskyAuth.active = true
                                                                    },
                                                                },
                                                              })
                                                            : _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_check_light.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.confirmRefresh(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                          _c("span", [
                                                            _vm._v(" "),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : !!item.bot_status &&
                                                    item.bot_status == 2
                                                  ? [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text:
                                                              _vm.$t(
                                                                "dash.bots.status_near_expiration"
                                                              ) +
                                                              new Date(
                                                                item.bot_error
                                                              ).toLocaleDateString(),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("vs-avatar", {
                                                            attrs: {
                                                              color:
                                                                "transparent",
                                                              size: "18px",
                                                              src: require("../../../assets/img/icon_warn.svg"),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.confirmRefresh(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _c("a", {
                                                            attrs: {
                                                              href: "#",
                                                            },
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "dash.pages.refreshLabel"
                                                                )
                                                              ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.confirmRefresh(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : item.bot_status == 0 &&
                                                    !_vm.checkLock(
                                                      "source_choice"
                                                    )
                                                  ? [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: item.bot_error,
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("vs-avatar", {
                                                            attrs: {
                                                              color:
                                                                "transparent",
                                                              size: "18px",
                                                              src: require("../../../assets/img/icon_stop.svg"),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                ;[
                                                                  "Admin",
                                                                  "Editor",
                                                                ].includes(
                                                                  _vm.getUserRole
                                                                )
                                                                  ? _vm.goToSettings()
                                                                  : null
                                                              },
                                                            },
                                                          }),
                                                          item.network ==
                                                          "bluesky"
                                                            ? _c("a", {
                                                                attrs: {
                                                                  href: "#",
                                                                },
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.pages.refreshLabel"
                                                                      )
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.blueskyAuth.active = true
                                                                    },
                                                                },
                                                              })
                                                            : _c("a", {
                                                                attrs: {
                                                                  href: "#",
                                                                },
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.pages.refreshLabel"
                                                                      )
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.confirmRefresh(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                          _c("span", [
                                                            _vm._v(" "),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : item.bot_status == 0 &&
                                                    item.network == "linkedin"
                                                  ? [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: _vm.$t(
                                                              "dash.bots.status_expired"
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("vs-avatar", {
                                                            attrs: {
                                                              color:
                                                                "transparent",
                                                              size: "18px",
                                                              src: require("../../../assets/img/icon_stop.svg"),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.confirmRefresh(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _c("a", {
                                                            attrs: {
                                                              href: "#",
                                                            },
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "dash.pages.refreshLabel"
                                                                )
                                                              ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.confirmRefresh(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : item.bot_status == 3
                                                  ? [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: _vm.$t(
                                                              item.bot_error
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("vs-avatar", {
                                                            attrs: {
                                                              color:
                                                                "transparent",
                                                              size: "18px",
                                                              src: require("../../../assets/img/icon_stop.svg"),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                ;[
                                                                  "Admin",
                                                                  "Editor",
                                                                ].includes(
                                                                  _vm.getUserRole
                                                                )
                                                                  ? _vm.reactivateBot(
                                                                      item.id
                                                                    )
                                                                  : null
                                                              },
                                                            },
                                                          }),
                                                          _c("a", {
                                                            attrs: {
                                                              href: "#",
                                                            },
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "dash.sources.enable"
                                                                )
                                                              ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                ;[
                                                                  "Admin",
                                                                  "Editor",
                                                                ].includes(
                                                                  _vm.getUserRole
                                                                )
                                                                  ? _vm.reactivateBot(
                                                                      item.id
                                                                    )
                                                                  : null
                                                              },
                                                            },
                                                          }),
                                                          _c("span", [
                                                            _vm._v(" "),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : _vm.checkLock(item.network)
                                                  ? [
                                                      item.network == "bluesky"
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: item.bot_error,
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_stop.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.blueskyAuth.active = true
                                                                    },
                                                                },
                                                              }),
                                                              _c("a", {
                                                                attrs: {
                                                                  href: "#",
                                                                },
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.pages.refreshLabel"
                                                                      )
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.blueskyAuth.active = true
                                                                    },
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        : _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: item.bot_error,
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("vs-avatar", {
                                                                attrs: {
                                                                  color:
                                                                    "transparent",
                                                                  size: "18px",
                                                                  src: require("../../../assets/img/icon_stop.svg"),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.confirmRefresh(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _c("a", {
                                                                attrs: {
                                                                  href: "#",
                                                                },
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.pages.refreshLabel"
                                                                      )
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.confirmRefresh(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                    ]
                                                  : item.network == "bluesky"
                                                  ? [
                                                      _c("vs-avatar", {
                                                        staticStyle: {
                                                          cursor: "default",
                                                        },
                                                        attrs: {
                                                          color: "transparent",
                                                          size: "18px",
                                                          src: require("../../../assets/img/icon_stop.svg"),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.blueskyAuth.active = true
                                                          },
                                                        },
                                                      }),
                                                      _c("a", {
                                                        attrs: { href: "#" },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.$t(
                                                              "dash.pages.refreshLabel"
                                                            )
                                                          ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.blueskyAuth.active = true
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  : [
                                                      _c("vs-avatar", {
                                                        staticStyle: {
                                                          cursor: "default",
                                                        },
                                                        attrs: {
                                                          color: "transparent",
                                                          size: "18px",
                                                          src: require("../../../assets/img/icon_stop.svg"),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.confirmRefresh(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _c("a", {
                                                        attrs: { href: "#" },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.$t(
                                                              "dash.pages.refreshLabel"
                                                            )
                                                          ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.confirmRefresh(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ]),
                                          _c("vs-td", [
                                            _c(
                                              "div",
                                              { staticClass: "action-page" },
                                              [
                                                ["Admin", "Editor"].includes(
                                                  _vm.getUserRole
                                                )
                                                  ? [
                                                      !_vm.checkLock(
                                                        item.network
                                                      ) ||
                                                      (!_vm.isUserPremiumActive &&
                                                        index != 0 &&
                                                        !_vm.isUserPartner)
                                                        ? _c(
                                                            "vs-button",
                                                            {
                                                              staticClass:
                                                                "btn-large btn-img remove",
                                                              attrs: {
                                                                color:
                                                                  "#6a1f4c",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "delete"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("p", [
                                                                _vm._v(
                                                                  "Supprimer"
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _c(
                                                            "vs-button",
                                                            {
                                                              staticClass:
                                                                "btn-large btn-img remove",
                                                              attrs: {
                                                                color:
                                                                  "#6a1f4c",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.deleteLinked(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "delete"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("p", [
                                                                _vm._v(
                                                                  "Supprimer"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    })
                                  },
                                },
                              ],
                              null,
                              false,
                              4244608841
                            ),
                          },
                          [
                            _c(
                              "template",
                              { slot: "thead" },
                              [
                                _c(
                                  "vs-th",
                                  {
                                    staticClass: "name",
                                    attrs: { sortKey: "name" },
                                  },
                                  [_vm._v("Nom")]
                                ),
                                _c(
                                  "vs-th",
                                  {
                                    staticClass: "type",
                                    attrs: { sortKey: "network" },
                                  },
                                  [_vm._v("Type")]
                                ),
                                _c("vs-th"),
                                _c("vs-th"),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm.activeConciergerie
        ? _c("component-conciergerie-form", {
            attrs: {
              page: _vm.activeConciergerie,
              activeConciergerie: _vm.activeConciergerie,
            },
            on: {
              getPagesEvent: _vm.getPagesEvent,
              closeActiveConciergerie: _vm.closeActiveConciergerie,
            },
          })
        : _vm._e(),
      _c(
        "vs-popup",
        {
          staticClass: "overlay posts-overlay-change-plan-conciergerie",
          attrs: {
            title: _vm.$t(
              "dash.plan.active_conciergerie_to_get_features_general"
            ),
            active: _vm.changePlanConciergerie,
          },
          on: {
            "update:active": function ($event) {
              _vm.changePlanConciergerie = $event
            },
          },
        },
        [
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "dash.plan.active_conciergerie_to_get_features_general.content"
                )
              )
            ),
          ]),
          _c("br"),
          _c(
            "vs-button",
            {
              staticClass: "btn-large btn-img",
              attrs: { color: "#303030", "vs-type": "filled" },
              on: { click: _vm.goToSettings },
            },
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("dash.button.changeplan")))]),
              _c("img", {
                attrs: {
                  src: require("../../../assets/img/icon_unlock.svg"),
                  alt: "unlock",
                },
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          staticClass: "overlay pages-overlay-edit",
          attrs: {
            title: _vm.$t("dash.pages.edit_page"),
            active: _vm.editPageName,
          },
          on: {
            "update:active": function ($event) {
              _vm.editPageName = $event
            },
          },
        },
        [
          _vm.editPageName
            ? _c(
                "div",
                { staticClass: "edit-page-popup" },
                [
                  _c("vs-input", {
                    attrs: { placeholder: _vm.$t("dash.pages.edit_page_name") },
                    model: {
                      value: _vm.editPageName.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.editPageName, "name", $$v)
                      },
                      expression: "editPageName.name",
                    },
                  }),
                  _c("vs-button", { on: { click: _vm.saveEditPageName } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("dash.button.save")) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }